import React, { useState } from "react";
import DatePicker from "react-datepicker";
import {FcCalendar} from 'react-icons/fc';
import TextField from '@material-ui/core/TextField';

const TimePicker = (props) => {
  const [startDate, setStartDate] = useState(props.valueInField);
  const [noValue, setNoValue] = useState(true)
  const handleChange = (value, event) => {
    //alert("VAL: " + value + " EVENT: " + event.target.id)
    console.log("VALUE: " + value + " EVENT: " + event);
    console.log(value)
    
    props.triggerUpdateInParent(props.id, value)
    setStartDate(value)
    setNoValue(false)
  };
  const CustomInput = React.forwardRef((props,ref) => {
    return (
        <input
            className="date-picker-main-time"
            onClick={props.onClick}
            value={props.value}
            type="text"
            readOnly={true}
            ref={ref}
        />
    )
})
  //alert("PRPS: " + props.id + " ")
  //const [startDate, setStartDate] = useState(new Date());
  //const [startDate, setStartDate] = useState();
  return (
    <div style={{maxHeight:'65px', textAlign: 'center'}}>
        <span className={props.classesToAdd}></span>
        <div>
        <TextField
        id={props.id}
        label="Time"
        type="time"
        onChange={(value, e) => handleChange(value, e)} 
        defaultValue={props.valueInField}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          step: 60, // 5 min
        }}
        sx={{ width: 150 }}
      />
      {/*
          <TimePicker customInput={<CustomInput/>} 
          timeInputLabel="Time:" 
          showTimeInput 
          dateFormat="MM/dd/yyyy h:mm aa" 
          id={props.id} 
          className="date-picker-main-time" 
          selected={startDate} 
          onChange={(value, e) => handleChange(value, e)} 
      />*/}
        </div>
    </div>
  );
};

export default TimePicker;